import { Component,  Input } from '@angular/core';
import { Exhibitor } from 'globals/store/exhibitors.data';
import { Sponsor } from 'globals/store/sponsors.data';
import { JoiResource } from 'globals/store/resources.data';
import { PersonCardComponent } from './person-card.component';

@Component({
    selector: 'sponsor-card',
    template: `
<person-card [size]="size" [cardTitle]="sponsor.name || ''" [hidePhoto]="hidePhoto || !sponsor.logoUrl" [photoUrl]="sponsor.logoUrl" [bold]="bold" [disableSelect]="true">
</person-card>
`,
    standalone: true,
    imports: [PersonCardComponent],
})

export class SponsorCardComponent {
  @Input() sponsor: Sponsor | Exhibitor | JoiResource
  @Input() hidePhoto = false
  @Input() size = 36
  @Input() bold = false
  @Input() onlyName = false
}
